import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { getPeopleCardRouteForEmailAddress } from '../utils/getPeopleCardRouteForEmailAddress';
import {
    setPeopleCardRoute,
    PeopleCardRouteViewType,
    PeopleCardDatapointConfig,
    PeopleCardMountProps,
    PeopleCardRoute,
} from 'mini-people-card-route-store';

export default function openPeopleCard(
    recipient: EmailAddressWrapper,
    source?: string,
    subSource?: string
) {
    const { MailboxType } = recipient;
    const { routeId, routeIdType } = getPeopleCardRouteForEmailAddress(recipient);

    if (routeId) {
        const peopleCardRoute: PeopleCardRoute = {
            routeId,
            routeIdType,
            view: PeopleCardRouteViewType.Front,
        };
        const mountProps: PeopleCardMountProps = {
            emailAddress: recipient,
        };
        const datapointConfig: PeopleCardDatapointConfig = {
            source,
            subSource,
            cardType: MailboxType,
        };

        setPeopleCardRoute(peopleCardRoute, mountProps, datapointConfig);
    }
}
